export default __webpack_public_path__ + "static/media/bg18.5441f1b8.jpg";